module.exports = __webpack_public_path__ + "static/screenshot-excel-79cb97421b2dc36cbdc8da13bdaee64a.png";